// The Get involved / quick links block's config, read the same way by
// both templates. No imports, so the harness can run it in node.

export const QUICK_LINK_DEFAULTS = [
    { icon: 'membership', title: 'Join', text: 'Become a member and help keep the trails open.', href: '/get-involved' },
    { icon: 'heart', title: 'Donate', text: 'Fund tools, materials and the projects that keep trails open.', href: '/get-involved#donate' },
    { icon: 'hand', title: 'Volunteer', text: 'Join a crew day. No experience needed, tools provided.', href: '/get-involved#volunteer' },
    { icon: 'newspaper', title: 'News', text: 'Trail work reports, closures and community updates.', href: '/news' },
    { icon: 'event', title: 'Events', text: 'Group rides, trail work days, workshops and races.', href: '/events' },
];

export const SUBSCRIBE_DEFAULTS = {
    enabled: true,
    title: 'Subscribe',
    text: 'The trail report in your inbox.',
    placeholder: 'Email',
    button_label: 'Go',
    success_message: 'You are on the list.',
};

// A tile with no title is a half-added row in the editor; it renders
// as an icon and an arrow pointing at nothing, so it is left off.
export function quickLinkItems(config) {
    const rows = Array.isArray(config?.links) ? config.links : [];
    return rows
        .filter((l) => l && String(l.title || '').trim() !== '')
        .map((l) => ({
            icon: l.icon || 'star',
            title: String(l.title).trim(),
            text: String(l.text || '').trim(),
            href: String(l.href || '').trim(),
        }));
}

// null when the tile is switched off. Blank fields fall back to the
// defaults so a cleared box never renders an empty button.
export function quickLinksSubscribe(config) {
    const s = config?.subscribe;
    if (!s || s.enabled === false) return null;
    const pick = (k) => (String(s[k] ?? '').trim() || SUBSCRIBE_DEFAULTS[k]);
    return {
        title: pick('title'),
        text: String(s.text ?? SUBSCRIBE_DEFAULTS.text).trim(),
        placeholder: pick('placeholder'),
        button_label: pick('button_label'),
        success_message: pick('success_message'),
    };
}
